import {
  EditorState,
} from 'draft-js';

import {
  Icon,
  Tooltip,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import LinkStyle from './LinkStyle';
import LinkDocument from './LinkDocument';
import { ListIcon, ListOrderedIcon } from './Icons'
import * as S from '../styled';

interface Props {
  editorState: EditorState
  showInsertLink?: boolean
  isLinkPopupOpen: boolean
  setIsLinkPopupOpen: { (isOpen: boolean): void }
  onLink: { (text: string, url: string): void }
  onToggle: { (style: string): void }
}

const BlockStyle = ({
  editorState,
  showInsertLink,
  isLinkPopupOpen,
  setIsLinkPopupOpen,
  onLink,
  onToggle,
}: Props) => {
  const BLOCK_TYPES = [
    {
      icon: ListIcon,
      style: 'unordered-list-item',
      tooltip: 'Unordered list (Tab)',
    },
    {
      icon: ListOrderedIcon,
      style: 'ordered-list-item',
      tooltip: 'Ordered list',
    },
  ];

  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  const Blocks = BLOCK_TYPES.map(type => (
    <Tooltip
      key={type.style}
      body={type.tooltip}
      positions={['top']}
    >
      <S.Control
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onToggle(type.style);
        }}
        isActive={type.style === blockType}
      >
        <type.icon />
      </S.Control>
    </Tooltip>
  ));

  return (
    <Flex spacing={10}>
      {Blocks}
      {showInsertLink && (
        <LinkStyle
          isOpen={isLinkPopupOpen}
          setIsOpen={setIsLinkPopupOpen}
          onInsert={(url) => {
            const content = editorState.getCurrentContent();
            const start = selection.getStartOffset();
            const end = selection.getEndOffset();
            const blockKey = selection.getStartKey();
            const blockText = content.getBlockForKey(blockKey).getText();
            const selectedText = blockText.slice(start, end);
            onLink(selectedText || url, url)
          }}
        />
      )}
      <LinkDocument
        onLink={(doc) => {
          onLink(doc.name, `document:${doc.id}`);
        }}
      />
    </Flex>
  );
};

export default BlockStyle;
